import LockClockRoundedIcon from '@mui/icons-material/LockClockRounded'
import { Button, Stack, Typography } from '@mui/material'

import { useAuth } from '@/features/auth/hooks/useAuth'

/**
 * SA-5 (Sección 17) — pantalla controlada para un usuario cuya
 * organización fue suspendida. Nunca muestra stack trace, Organization
 * ID, motivo comercial ni "kill switch" — solo el mensaje neutro que
 * pide el encargo. El usuario puede cerrar sesión; si su organización
 * se reactiva, un simple refresh (o volver a iniciar sesión) restaura
 * el acceso sin ninguna acción adicional de su parte.
 */
export function OrganizationSuspendedPage() {
  const { logout } = useAuth()

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ minHeight: '100vh', textAlign: 'center', px: 3 }}
    >
      <LockClockRoundedIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
      <Typography variant="h6">Acceso suspendido</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
        El acceso de esta organización se encuentra suspendido. Contacta al administrador de tu
        servicio.
      </Typography>
      <Button variant="outlined" onClick={() => void logout()} sx={{ mt: 2 }}>
        Cerrar sesión
      </Button>
    </Stack>
  )
}
